import { Col, Row } from "react-bootstrap";
import { NFDateInput } from "../../../../Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";
import { NFTextInput } from "../../../../Shared/NewForms/NFTextInput";
import { NFLookupCompany } from "../../../../Shared/NewForms/NFLookupCompany";
import { NFLookupCashflowItem } from "../../../../Shared/NewForms/NFLookupCashflowItem";
import { EnumHelper } from "../../../../../helpers/EnumHelper";
import { NFLookupInput } from "../../../../Shared/NewForms/NFLookupInput";
import { NFLookupDivision } from "../../../../Shared/NewForms/NFLookupDivision";
import { NFLookupCashRegister } from "../../../../Shared/NewForms/NFLookupCashRegister";
import { NFLookupPaymentRequests } from "../../../../Shared/NewForms/NFLookupPaymentRequests";
import { NFLookupCurrency } from "../../../../Shared/NewForms/NFlookupCurrency";
import { NFormTable } from "../../../../Shared/NewForms/NFormTable";
import { NFIntInput } from "../../../../Shared/NewForms/NFIntInput";
import { useState } from "react";
import { NFLookupVendorCustomer } from "../../../../Shared/NewForms/NFLookupVendorCustomer";
import { NFLookupContract } from "../../../../Shared/NewForms/NFLookupContract";
import { useFormContext } from "react-hook-form";

const ExpenseCashsRefundToCustomerDetail = () => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const handleListChange = (selectedOption: number) => {
    if (selectedOption === 0) {
      setShowModal(true);
    } else if (selectedOption === 1) {
      setShowModal(false);
    }
  };
  return (
    <Row>
      <Col sm={6}>
        <NFLookupVendorCustomer fieldName="vendorCustomerId" title={t("VendorsAndCustomers")} required />
      </Col>
      <Col sm={6}>
        <NFLookupContract fieldName="contractId" title={t("Contract")} />
      </Col>

      {/* {showModal && (
        <NFormTable fieldArray={"payments"}>
          <NFLookupCurrency title={t("Currency")} fieldName="currencyId" width={500} />
          <NFIntInput title={t("Amount")} fieldName="amount" />
          <NFIntInput title={t("CurrencyAmount")} fieldName="currencyAmount" />
        </NFormTable>
      )} */}
    </Row>
  );
};

export default ExpenseCashsRefundToCustomerDetail;
